"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4640],{

/***/ 75172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ DropDownArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var DropDownArrow = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "15.691",
        height: props.height || "8.949",
        viewBox: "0 0 15.691 8.949",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            id: "Path_132908",
            fill: props.fillColor || "000000",
            "data-name": "Path 132908",
            d: "M172.146,128.242a.842.842,0,0,0-1.263.093,1.048,1.048,0,0,0,.085,1.384l6.389,6.126-6.389,6.126a1.047,1.047,0,0,0-.085,1.384.842.842,0,0,0,1.263.093l7.159-6.865a1.044,1.044,0,0,0,0-1.477Zm0,0",
            transform: "translate(143.69 -170.661) rotate(90)"
        })
    });
};


/***/ }),

/***/ 38173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72651);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86812);
/* harmony import */ var _AtomicComponents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38855);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36623);









var timingDuration = 3;
var OrderConfirmLoader = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        isConfirmed: false,
        confirmCount: 0
    }), confirmStatus = ref14[0], setConfirmStatus = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(timingDuration), timeLeft = ref15[0], setTimeLeft = ref15[1];
    var storeInfo = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    });
    var cart = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.cartReducer;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!timeLeft && !confirmStatus.isConfirmed) {
            props.submitAction();
            props.closeModal();
            return;
        }
        var intervalId = setInterval(function() {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        timeLeft,
        confirmStatus.isConfirmed
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.isVisible) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "scroll";
        }
    }, [
        props.visible
    ]);
    var confirmButtonClick = function() {
        props.submitAction();
        props.closeModal();
    };
    var cancelButtonClick = function() {
        setConfirmStatus(function(confirmStatus) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, confirmStatus), {
                isConfirmed: !confirmStatus.isConfirmed,
                confirmCount: confirmStatus.confirmCount + 1
            });
        });
    };
    return props.isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        visible: props.isVisible,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0,
            maxWidth: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_4__/* .deviceWidth */ .o <= 766 ? "100%" : 480
        },
        animation: "slideUp",
        className: "bottom-modal",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "OrderConfirmLoader",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "payment-section",
                    style: {
                        border: "none"
                    },
                    children: [
                        confirmStatus.isConfirmed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "payment-closeicon",
                            onClick: function() {
                                return props.closeModal();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                                alt: "cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("placing_order_cta")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "payment-section",
                    style: {
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "info-header info-header--main",
                            children: "Select payment option"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "payment-selection",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "payment-selection__radio",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "payment-selection__radio--icon",
                                        style: {
                                            backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "payment-selection__radio--icon-inner",
                                            style: {
                                                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "payment-selection__info",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "payment-selection__info--header",
                                            children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "payment-selection__info--amount",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "payment-selection__info--amount-text",
                                                    children: "Total Amount:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "payment-selection__info--amount-price",
                                                    style: {
                                                        color: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color
                                                    },
                                                    children: [
                                                        "₹",
                                                        cart.buyer_pay_value
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "payment-section",
                    children: confirmStatus.isConfirmed ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AtomicComponents__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                        roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref6 = storeInfo.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness,
                        backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color,
                        py: "15px",
                        px: "10px",
                        fontSize: 18,
                        fluid: true,
                        label: "Place Order",
                        fontColor: "#ffffff",
                        onClick: confirmButtonClick
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "payment-cancellation",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "payment-cancellation__bar",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "payment-cancellation__bar--animated",
                                    style: {
                                        backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref9 = storeInfo.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color,
                                        animationDuration: "".concat(timingDuration, "s")
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "payment-cancellation__btn",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AtomicComponents__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                                    variant: "outline",
                                    roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref11 = storeInfo.theme) === null || ref11 === void 0 ? void 0 : ref11.roundness,
                                    backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref12 = storeInfo.theme) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.colors) === null || ref13 === void 0 ? void 0 : ref13.primary_color,
                                    py: "11px",
                                    px: "18px",
                                    fontSize: "15",
                                    fluid: true,
                                    label: "Cancel",
                                    fontColor: "#ffffff",
                                    onClick: cancelButtonClick
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrderConfirmLoader);


/***/ }),

/***/ 74640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_AddDelivery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/Common/Premium/Input/Input.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  ",
        ";\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &,\n  &:focus,\n  &:hover {\n    border: 0;\n    border-radius: 0;\n    border-bottom: 1px solid #c3c3c3;\n    color: #000;\n    outline: none;\n    position: relative;\n    z-index: 2;\n    box-shadow: none;\n    background-color: transparent;\n    width: 100%;\n    padding: 5px;\n\n    &::placeholder {\n      opacity: 0.7;\n    }\n  }\n\n  ",
        ";\n\n  &:disabled,\n  &[readonly] {\n    background-color: #e9ecef;\n    opacity: 0.5;\n  }\n\n  & + label {\n    position: absolute;\n    top: -35px;\n    left: 11px;\n    transition: 0.2s all;\n    z-index: 1;\n    color: ",
        ";\n    font-size: 12px;\n  }\n\n  &:not(:empty) + label,\n  &:focus + label {\n    top: -35px;\n    font-size: 12px;\n    color: ",
        ";\n  }\n\n  &[value=''] + label {\n    top: -16px;\n    left: 6px;\n    color: #999;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var DSInput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DSInput",
    componentId: "sc-a1d2bc35-0"
})(_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.marginBottom) !== undefined ? "margin-bottom: ".concat(props === null || props === void 0 ? void 0 : props.marginBottom, "px") : "margin-bottom: 40px";
});
var FormControl = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "FormControl",
    componentId: "sc-a1d2bc35-1"
})(_templateObject1(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isBlinkingCursorVisible) ? "caret-color: transparent" : "";
}, function(props) {
    return props.fontColor;
}, function(props) {
    return props.fontColor;
});

;// CONCATENATED MODULE: ./src/components/Common/Premium/Input/index.js






var Input = function(props) {
    var ref;
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer;
    }).theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DSInput, {
        marginBottom: props === null || props === void 0 ? void 0 : props.marginBottom,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                fontColor: theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: "".concat((props === null || props === void 0 ? void 0 : props.labelClasses) || "!tw-left-[5px]", " "),
                children: props.label
            })
        ]
    });
};
/* harmony default export */ var Premium_Input = (Input);

// EXTERNAL MODULE: ./src/components/DesignSystem/OrderConfirmLoader/index.js
var OrderConfirmLoader = __webpack_require__(38173);
// EXTERNAL MODULE: ./src/redux/actions/user.js
var user = __webpack_require__(56173);
// EXTERNAL MODULE: ./src/redux/actions/auth.js
var auth = __webpack_require__(68060);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var actions_cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/utils/addDeliveryInfoInCart.js
var addDeliveryInfoInCart = __webpack_require__(68068);
// EXTERNAL MODULE: ./src/utils/isDeliveryPincodeBased.js
var isDeliveryPincodeBased = __webpack_require__(84110);
;// CONCATENATED MODULE: ./src/utils/jsonEqual.js
function jsonEqual(obj1, obj2) {
    if (JSON.stringify(obj1) === JSON.stringify(obj2)) return true;
    return false;
}

// EXTERNAL MODULE: ./src/utils/isValidEmail.js
var isValidEmail = __webpack_require__(26188);
;// CONCATENATED MODULE: ./src/containers/AddDelivery/AddDelivery.styles.js

function AddDelivery_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  background: white;\n  justify-content: flex-end;\n  margin: 0px 16px 16px 20px;\n"
    ]);
    AddDelivery_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AddDelivery_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  background: ",
        ";\n  color: white;\n  padding: 16px 32px;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  font-size: 16px;\n  font-width: 600;\n  border-radius: ",
        ";\n  cursor: pointer;\n  width: 100%;\n  justify-content: center;\n\n  @media screen and (max-width: 767px) {\n    margin-bottom: 0px;\n  }\n"
    ]);
    AddDelivery_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: ",
        ";\n  cursor: pointer;\n  z-index: 2;\n  height: fit-content;\n  width: fit-content;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-left: 1px;\n  width: 100%;\n  position: absolute;\n  z-index: 3;\n  background : white;\n  transform: translate(7px,25px);\n  flex-direction: column;\n  border: 1px solid #EAEAEC;\n  border-radius: 8px;\n \n  @media screen and (max-width : 767px){\n    width 87.5vw;\n    transform: translate(-2px,26px);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 12px 0px;\n  margin-left: 1px;\n  width: 90%;\n  position: absolute;\n  z-index: 3;\n  background: white;\n  transform: translate(0px, 25px);\n  flex-direction: column;\n  border: 1px solid #eaeaec;\n  border-radius: 8px;\n  overflow: scroll;\n  max-height: 20vh;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 14px;\n  padding-right: 6px;\n  font-size: 14px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  ",
        "\n  :hover {\n    background-color: #f2f2f2;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 14px;\n  padding-right: 6px;\n  font-size: 14px;\n  padding-bottom: ",
        "px;\n  padding-top: ",
        "px;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n  :hover {\n    background-color: #f2f2f2;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var SaveAddressCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SaveAddressCtaContainer",
    componentId: "sc-2210db39-0"
})(AddDelivery_styles_templateObject());
var SaveAddressCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SaveAddressCta",
    componentId: "sc-2210db39-1"
})(AddDelivery_styles_templateObject1(), function(props) {
    return props.color || "#FAFAFA";
}, function(props) {
    return props.borderRadius;
});
var GenderDropDownArrowContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GenderDropDownArrowContainer",
    componentId: "sc-2210db39-2"
})(_templateObject2());
var GenderDropDownArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GenderDropDownArrow",
    componentId: "sc-2210db39-3"
})(_templateObject3(), function(props) {
    return props.showGenderDropDown ? "translate(-15px, 4px) rotate(180deg)" : "translate(-15px, 4px) rotate(0deg)";
});
var GenderDropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GenderDropDownContainer",
    componentId: "sc-2210db39-4"
})(_templateObject4());
var CounntryDropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CounntryDropDownContainer",
    componentId: "sc-2210db39-5"
})(_templateObject5());
var DropDownElementContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DropDownElementContainer",
    componentId: "sc-2210db39-6"
})(_templateObject6(), function(props) {
    return props.selected ? "background-color: #bfbfbf;" : "";
});
var GenderDropDownElementContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "GenderDropDownElementContainer",
    componentId: "sc-2210db39-7"
})(_templateObject7(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.pb) && (props === null || props === void 0 ? void 0 : props.pb);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.pt) && (props === null || props === void 0 ? void 0 : props.pt);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.mt) && (props === null || props === void 0 ? void 0 : props.mt);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.mb) && (props === null || props === void 0 ? void 0 : props.mb);
});

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(52388);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/utils/triggerGetServiceableAddressId.js + 2 modules
var triggerGetServiceableAddressId = __webpack_require__(67058);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(26706);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(70758);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
// EXTERNAL MODULE: ./src/assets/svgExports/DropDownArrow.js
var DropDownArrow = __webpack_require__(75172);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./src/utils/useIsClickOutside.js
var useIsClickOutside = __webpack_require__(5305);
;// CONCATENATED MODULE: ./src/containers/AddDelivery/Components/CountryInput/index.tsx











var CountryInput = function(param) {
    var country = param.country, INDIA_COUNTRY_OBJECT = param.INDIA_COUNTRY_OBJECT, setCountry = param.setCountry, countriesData = param.countriesData, setCountriesData = param.setCountriesData;
    var handleShowCountryDropDown = function handleShowCountryDropDown() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setShowCountryDropDown(!showCountryDropDown);
    };
    var onSelectCountry = function onSelectCountry(country, e) {
        handleShowCountryDropDown(e);
        setCountry(country);
        setCountriesData(function(countriesData) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, countriesData), {
                defaultCountry: country
            });
        });
    };
    var renderCountryDropDown = function renderCountryDropDown() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CounntryDropDownContainer, {
            children: countriesLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center-l pa3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
            }) : (countriesData.countries.length > 0 ? countriesData.countries : [
                INDIA_COUNTRY_OBJECT
            ]).map(function(country, index) {
                var ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownElementContainer, {
                    id: countryElementId(country === null || country === void 0 ? void 0 : country.id),
                    selected: ((ref = countriesData.defaultCountry) === null || ref === void 0 ? void 0 : ref.id) === (country === null || country === void 0 ? void 0 : country.id),
                    onClick: function(e) {
                        return onSelectCountry(country, e);
                    },
                    children: country === null || country === void 0 ? void 0 : country.country
                }, index);
            })
        });
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(false), countriesLoading = ref[0], setCountriesLoading = ref[1];
    var ref1 = (0,react.useState)(false), showCountryDropDown = ref1[0], setShowCountryDropDown = ref1[1];
    var countryDropDownRef = (0,react.useRef)(null);
    var countryElementId = function(id) {
        return "country-".concat(id);
    };
    (0,useIsClickOutside/* default */.Z)(countryDropDownRef, setShowCountryDropDown, false);
    (0,react.useEffect)(function() {
        handleCountryDropdown();
    }, [
        showCountryDropDown
    ]);
    var handleCountryDropdown = function() {
        if (showCountryDropDown) {
            var ref, ref1;
            (ref = countryDropDownRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollIntoView) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
            if (countriesData.countries.length === 0) {
                setCountriesLoading(true);
                dispatch((0,user/* fetchCountriesList */.Kr)({}, fetchCountriesCallback));
            } else {
                var ref2;
                scrollToCountry(countriesData === null || countriesData === void 0 ? void 0 : (ref2 = countriesData.defaultCountry) === null || ref2 === void 0 ? void 0 : ref2.id);
            }
        }
    };
    var fetchCountriesCallback = function(countriesList, defaultCountry) {
        setCountriesLoading(false);
        if (country && country !== (defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.country)) {
            defaultCountry = (countriesList === null || countriesList === void 0 ? void 0 : countriesList.find(function(countryData) {
                return country === (countryData === null || countryData === void 0 ? void 0 : countryData.country);
            })) || defaultCountry;
        }
        setCountriesData({
            countries: countriesList,
            defaultCountry: defaultCountry
        });
        /**
     * setTimeout is used to defer the 'scrollToCountry' function.
     * This will ensure that 'scrollToCountry' is called after re-rendering is done after 'setCountriesData'
     */ setTimeout(function() {
            scrollToCountry(defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.id);
        }, 0);
    };
    var scrollToCountry = function(countryId) {
        var countryDropdownElement = document.getElementById(countryElementId(countryId));
        countryDropdownElement && countryDropdownElement.scrollIntoView();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-100 relative flex-column mb4-ns",
        ref: countryDropDownRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function(e) {
                    return handleShowCountryDropDown(e);
                },
                className: "flex flex-row w-100 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                        label: "Country *",
                        type: "text",
                        id: "country",
                        isBlinkingCursorVisible: true,
                        marginBottom: 0,
                        value: country,
                        style: {
                            width: "90%"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderDropDownArrow, {
                        showGenderDropDown: showCountryDropDown,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrow/* DropDownArrow */.s, {
                            fill: "#000000"
                        })
                    })
                ]
            }),
            showCountryDropDown && renderCountryDropDown()
        ]
    });
};
/* harmony default export */ var Components_CountryInput = (CountryInput);

// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
;// CONCATENATED MODULE: ./src/containers/AddDelivery/Constants/index.tsx
var INDIA_COUNTRY_OBJECT = {
    id: 103,
    country: "India",
    aplha_2_code: "",
    alpha_3_code: ""
};
var VALIDATION_TYPES = {
    EMAIL: "email",
    ALPHA_NUMERIC: "alpha_numeric",
    ALPHA_NUMERIC_INTERNATIONAL_PINCODE: "alpha_numeric_international_pincode",
    ALPHA_SPACE: "alpha_space",
    ADDRESS: "address",
    NUMERIC: "numeric"
};
var FIELDS_ID = {
    Pincode: "pincodeInput",
    Landmark: "landmarkInput",
    Address1: "address1Input",
    Address2: "address2Input",
    Name: "userNameInput",
    City: "cityInput",
    State: "stateInput",
    EmailId: "emailIdInput",
    AlternatePhone: "alternatePhone",
    Username: "userNameInput",
    Age: "ageInput",
    Gender: "genderInput",
    CustomFieldValue: "customFieldValue"
};
var ADDRESS_TYPES = {
    HOME: "home",
    WORK: "work",
    OTHERS: "others"
};
var ADDRESS_NAMES = {
    HOME: "Home",
    WORK: "Work",
    OTHERS: "Others"
};

;// CONCATENATED MODULE: ./src/containers/AddDelivery/Components/AgeAndGenderInput/index.tsx









var AgeAndGenderInput = function(param) {
    var state = param.state, handleInputChange = param.handleInputChange, setGender = param.setGender, invalidInputIdsMap = param.invalidInputIdsMap;
    var handleShowGenderDropDown = function handleShowGenderDropDown() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setShowGenderDropDown(!showGenderDropDown);
    };
    var handleGenderClick = function handleGenderClick(value, e) {
        handleShowGenderDropDown(e);
        setGender(value);
    };
    var renderGenderDropDown = function renderGenderDropDown() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderDropDownContainer, {
            children: Object.values(constants/* GENDER_TYPES */.ps).map(function(value, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderDropDownElementContainer, {
                    className: "tw-pb-[8px] tw-pt-[3px]",
                    onClick: function(e) {
                        handleGenderClick(value, e);
                    },
                    children: value
                }, index);
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react.useState)(false), showGenderDropDown = ref8[0], setShowGenderDropDown = ref8[1];
    var genderDropDownRef = (0,react.useRef)(null);
    (0,useIsClickOutside/* default */.Z)(genderDropDownRef, setShowGenderDropDown, false);
    (0,react.useEffect)(function() {
        showGenderDropDown && genderDropDownRef.current.scrollIntoView();
    }, [
        showGenderDropDown
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex ".concat(checkClientDeviceType/* IS_DESKTOP */.yn ? "flex-row" : "flex-column"),
        children: [
            (state === null || state === void 0 ? void 0 : (ref = state.selectedAddress) === null || ref === void 0 ? void 0 : (ref1 = ref.age) === null || ref1 === void 0 ? void 0 : ref1.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                marginBottom: checkClientDeviceType/* IS_DESKTOP */.yn ? 0 : 40,
                label: "Age ".concat(!(state === null || state === void 0 ? void 0 : (ref2 = state.selectedAddress) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.age) === null || ref3 === void 0 ? void 0 : ref3.is_mandatory) ? "(optional)" : "*"),
                type: "text",
                id: FIELDS_ID.Age,
                className: invalidInputIdsMap[FIELDS_ID.Age] ? "!tw-border-b-[#F63D60]" : "",
                labelClasses: invalidInputIdsMap[FIELDS_ID.Age] ? "!tw-text-[#F63D60]" : "",
                value: state.age,
                onChange: function(e) {
                    return handleInputChange("age", e.target.value, VALIDATION_TYPES.NUMERIC, 0, 3);
                }
            }),
            (state === null || state === void 0 ? void 0 : (ref4 = state.selectedAddress) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.gender) === null || ref5 === void 0 ? void 0 : ref5.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-100 relative flex-column",
                ref: genderDropDownRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: function(e) {
                            return handleShowGenderDropDown(e);
                        },
                        className: "flex flex-row w-100 relative ".concat(checkClientDeviceType/* IS_DESKTOP */.yn ? "ml20px" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                label: "Gender ".concat(!(state === null || state === void 0 ? void 0 : (ref6 = state.selectedAddress) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.gender) === null || ref7 === void 0 ? void 0 : ref7.is_mandatory) ? "(optional)" : "*"),
                                type: "text",
                                id: FIELDS_ID.Gender,
                                className: invalidInputIdsMap[FIELDS_ID.Gender] ? "!tw-border-b-[#F63D60]" : "",
                                labelClasses: invalidInputIdsMap[FIELDS_ID.Gender] ? "!tw-text-[#F63D60]" : "",
                                isBlinkingCursorVisible: true,
                                marginBottom: 0,
                                value: state.gender,
                                onChange: function(e) {
                                    return handleInputChange("gender", e.target.value, VALIDATION_TYPES.ALPHA_NUMERIC, 0, 100);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GenderDropDownArrow, {
                                showGenderDropDown: showGenderDropDown,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownArrow/* DropDownArrow */.s, {
                                    fill: "#000000"
                                })
                            })
                        ]
                    }),
                    showGenderDropDown && renderGenderDropDown()
                ]
            })
        ]
    });
};
/* harmony default export */ var Components_AgeAndGenderInput = (AgeAndGenderInput);

;// CONCATENATED MODULE: ./src/containers/AddDelivery/Components/CustomFields/CustomInput.js




var CustomInput = function(param) {
    var field = param.field, invalidInputIdsMap = param.invalidInputIdsMap, handleInputChange = param.handleInputChange;
    var ref, ref1;
    var ref2 = (0,react.useState)((field === null || field === void 0 ? void 0 : (ref = field.custom_field_value) === null || ref === void 0 ? void 0 : ref.text) || ""), input = ref2[0], setInput = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
        label: "".concat(field === null || field === void 0 ? void 0 : field.custom_field_name, " ").concat(!(field === null || field === void 0 ? void 0 : (ref1 = field.custom_field_value) === null || ref1 === void 0 ? void 0 : ref1.is_mandatory) ? "(optional)" : "*"),
        type: "text",
        id: FIELDS_ID.CustomFieldValue,
        className: invalidInputIdsMap["".concat(FIELDS_ID.CustomFieldValue).concat(field === null || field === void 0 ? void 0 : field.id)] ? "!tw-border-b-[#F63D60]" : "",
        labelClasses: invalidInputIdsMap["".concat(FIELDS_ID.CustomFieldValue).concat(field === null || field === void 0 ? void 0 : field.id)] ? "!tw-text-[#F63D60]" : "",
        value: input,
        onChange: function(e) {
            setInput(e.target.value);
            handleInputChange(field.id, e.target.value);
        }
    });
};
/* harmony default export */ var CustomFields_CustomInput = (CustomInput);

;// CONCATENATED MODULE: ./src/containers/AddDelivery/Components/CustomFields/index.js




var CustomFields = function(param) {
    var customFieldsList = param.customFieldsList, setCustomFieldList = param.setCustomFieldList, state = param.state, invalidInputIdsMap = param.invalidInputIdsMap;
    var isCustomFieldVisible = function isCustomFieldVisible() {
        return !!((customFieldsList === null || customFieldsList === void 0 ? void 0 : customFieldsList.length) && customFieldsList.some(function(field) {
            var ref;
            return field === null || field === void 0 ? void 0 : (ref = field.custom_field_value) === null || ref === void 0 ? void 0 : ref.visibility;
        }));
    };
    var handleInputChange = function handleInputChange(id, text) {
        var updatedCustomFieldList = customFieldsList === null || customFieldsList === void 0 ? void 0 : customFieldsList.map(function(field) {
            if ((field === null || field === void 0 ? void 0 : field.id) === id) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                    custom_field_value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field.custom_field_value), {
                        text: text
                    })
                });
            }
            return field;
        });
        setCustomFieldList(updatedCustomFieldList);
    };
    if (!isCustomFieldVisible()) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: customFieldsList === null || customFieldsList === void 0 ? void 0 : customFieldsList.map(function(field) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(CustomFields_CustomInput, {
                field: field,
                invalidInputIdsMap: invalidInputIdsMap,
                handleInputChange: handleInputChange
            }, field === null || field === void 0 ? void 0 : field.id);
        })
    });
};
/* harmony default export */ var Components_CustomFields = (CustomFields);

;// CONCATENATED MODULE: ./src/assets/svgExports/Location.js



function Location(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        viewBox: "0 0 20 20"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9.6 2A5.6 5.6 0 004 7.6C4 11.8 9.6 18 9.6 18s5.6-6.2 5.6-10.4A5.6 5.6 0 009.6 2zm0 7.6a2 2 0 112-2 2 2 0 01-2 2z",
            fill: props.color || "#000000"
        })
    }));
}

;// CONCATENATED MODULE: ./src/assets/svgExports/Work.js



function Work(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        viewBox: "0 0 20 20"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16.4 6.2h-3.2V4.6A1.594 1.594 0 0011.6 3H8.4a1.594 1.594 0 00-1.6 1.6v1.6H3.6a1.588 1.588 0 00-1.592 1.6L2 16.6a1.594 1.594 0 001.6 1.6h12.8a1.594 1.594 0 001.6-1.6V7.8a1.594 1.594 0 00-1.6-1.6zm-4.8 0H8.4V4.6h3.2z",
            fill: props.color || "#000000"
        })
    }));
}

;// CONCATENATED MODULE: ./src/assets/svgExports/Home.js



function Home(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.4 16v-4.588h3.2V16h4V9.882H18L10 3 2 9.882h2.4V16z",
                fill: props.color || "#000000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h20v20H0z",
                fill: "none"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/containers/AddDelivery/Components/AddressTypesAndName/index.tsx










var AddressTypesAndName = function(param) {
    var state = param.state, setState = param.setState;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref = (0,react.useState)(false), showOtherInputField = ref[0], setShowOtherInputField = ref[1];
    (0,react.useEffect)(function() {
        setShowOtherInputField(state.addressType === ADDRESS_TYPES.OTHERS);
    }, [
        state.addressType
    ]);
    var addressTypesData = [
        {
            Icon: Home,
            type: ADDRESS_TYPES.HOME,
            name: ADDRESS_NAMES.HOME
        },
        {
            Icon: Work,
            type: ADDRESS_TYPES.WORK,
            name: ADDRESS_NAMES.WORK
        },
        {
            Icon: Location,
            type: ADDRESS_TYPES.OTHERS,
            name: ADDRESS_NAMES.OTHERS
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "premium-address-container__typewrap premium-wrapper-around",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-w-full tw-flex-col tw-gap-[6px] md:tw-flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "form-group btn-group",
                    children: addressTypesData.map(function(param, index) {
                        var Icon = param.Icon, type = param.type, name = param.name;
                        var isSelected = state.addressType === type;
                        var border = isSelected ? "1px solid ".concat(themeColor) : "1px dashed #ccd2de";
                        var color = isSelected ? themeColor : "#000000";
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "pointer",
                            type: "button",
                            onClick: function() {
                                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                    addressType: type,
                                    addressName: name
                                }));
                                setShowOtherInputField(type === ADDRESS_TYPES.OTHERS);
                            },
                            style: {
                                border: border,
                                color: color
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    color: color || "#9e9e9e"
                                }),
                                name
                            ]
                        }, index);
                    })
                }),
                showOtherInputField && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "premium-address-container__wrap premium-wrapper-around tw-mt-[12px] !tw-p-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                        marginBottom: "0",
                        label: "Enter location nickname",
                        type: "text",
                        value: state.addressName,
                        onChange: function(e) {
                            var value = e.target.value;
                            if (value.trim().length <= 18) {
                                setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                    addressName: value
                                }));
                            }
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Components_AddressTypesAndName = (AddressTypesAndName);

// EXTERNAL MODULE: ./src/context/CartContext.ts
var CartContext = __webpack_require__(52271);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/containers/AddDelivery/index.js
/**
 * Add New Address page
 */ 





























var oldAddressData = {};
var AddDelivery = function(props) {
    var getRegexByValidationType = function getRegexByValidationType(validationType) {
        switch(validationType){
            case VALIDATION_TYPES.EMAIL:
                return /[^\w\@\-\.]/gi;
            case VALIDATION_TYPES.ALPHA_NUMERIC:
                return /[^\w/]/gi;
            case VALIDATION_TYPES.ALPHA_NUMERIC_INTERNATIONAL_PINCODE:
                return /^(?![a-zA-Z0-9\s,-]{0,15}$).*$/;
            case VALIDATION_TYPES.ALPHA_SPACE:
                return /[^a-z ]/gi;
            case VALIDATION_TYPES.ADDRESS:
                return /[^\w\s\-\,.(){}|*&#@!`";=/]/gi;
            case VALIDATION_TYPES.NUMERIC:
                return /[^0-9]/g;
            default:
                return /[^\d]/gi;
        }
    };
    var getIdByKey = function getIdByKey(key) {
        switch(key){
            case "user_name":
                return FIELDS_ID.Username;
            case "landmark":
                return FIELDS_ID.Landmark;
            case "pincode":
                return FIELDS_ID.Pincode;
            case "city":
                return FIELDS_ID.City;
            case "state":
                return FIELDS_ID.State;
            case "address1":
                return FIELDS_ID.Address1;
            case "address2":
                return FIELDS_ID.Address2;
            case "email_id":
                return FIELDS_ID.EmailId;
            case "age":
                return FIELDS_ID.Age;
            case "gender":
                return FIELDS_ID.Gender;
            case "alternate_phone":
                return FIELDS_ID.AlternatePhone;
            case "custom_field_value":
                return FIELDS_ID.CustomFieldValue;
            default:
                return "";
        }
    };
    var validateEmailError = function validateEmailError() {
        var emailID = state.email_id.trim();
        if (state.selectedAddress.email_id.is_mandatory) {
            if (!emailID) {
                return true;
            }
            if (!(0,isValidEmail/* isValidEmail */.v)(emailID)) {
                return true;
            }
            return false;
        } else if (emailID) {
            if (!(0,isValidEmail/* isValidEmail */.v)(emailID)) {
                return true;
            }
        }
        return false;
    };
    var validateAlternatePhoneError = function validateAlternatePhoneError() {
        if (state.selectedAddress.alternate_phone.is_mandatory) {
            var ref;
            if (state.alternate_phone.trim() === "") {
                return true;
            } else if (isIndiaSelected && ((ref = state.alternate_phone) === null || ref === void 0 ? void 0 : ref.length) < 10) {
                return true;
            }
            return false;
        } else return false;
    };
    var getCustomFieldDataList = function getCustomFieldDataList() {
        var renderCompleteCustomFieldValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref;
        if (!(state === null || state === void 0 ? void 0 : (ref = state.custom_field_data_list) === null || ref === void 0 ? void 0 : ref.length) || !isCustomFieldVisible()) {
            return [];
        }
        var updatedResult = customFieldList === null || customFieldList === void 0 ? void 0 : customFieldList.map(function(field) {
            var ref;
            if (renderCompleteCustomFieldValue) {
                return field;
            }
            var updatedCustomList = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                custom_field_value: (field === null || field === void 0 ? void 0 : (ref = field.custom_field_value) === null || ref === void 0 ? void 0 : ref.text) || ""
            });
            return updatedCustomList;
        });
        return updatedResult;
    };
    var renderSaveButton = function renderSaveButton() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveAddressCtaContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveAddressCta, {
                color: themeColor,
                onClick: onDeliverHereHandle,
                borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness),
                children: "Save & Deliver here"
            })
        });
    };
    var setGender = function setGender(selectedGender) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            gender: selectedGender
        }));
    };
    var setCountry = function setCountry(selectedCountry) {
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            country: selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.country,
            pincode: "",
            city: "",
            state: "",
            alternate_phone: ""
        }));
    };
    var isCustomFieldVisible = function isCustomFieldVisible() {
        return !!((customFieldList === null || customFieldList === void 0 ? void 0 : customFieldList.length) && customFieldList.some(function(field) {
            var ref;
            return field === null || field === void 0 ? void 0 : (ref = field.custom_field_value) === null || ref === void 0 ? void 0 : ref.visibility;
        }));
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37;
    var ref38 = (0,react.useContext)(CartContext/* CartContext */.A), showAddressError = ref38.showAddressError, setShowAddressError = ref38.setShowAddressError;
    var dispatch = (0,es/* useDispatch */.I0)();
    // const { edit_id } = router.query;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var ref39 = (0,react.useState)([]), customFieldList = ref39[0], setCustomFieldList = ref39[1];
    var ref40 = (0,react.useState)({
        user_name: "",
        landmark: "",
        pincode: "",
        city: "",
        state: "",
        country: "",
        address1: "",
        address2: "",
        addressName: ADDRESS_NAMES.HOME,
        isLocationOn: false,
        addressType: ADDRESS_TYPES.HOME,
        email_id: "",
        alternate_phone: "",
        deliveryType: checkRenderEnv/* IS_SERVER */.W6 ? "" : cart === null || cart === void 0 ? void 0 : cart.order_type,
        showOptionalFields: false,
        selectedAddress: null,
        age: "",
        gender: "",
        custom_field_data_list: [],
        missing_fields: []
    }), state = ref40[0], setState = ref40[1];
    var ref41 = (0,react.useState)(false), orderConfirmLoaderToggle = ref41[0], setOrderConfirmLoaderToggle = ref41[1];
    var ref42 = (0,react.useState)([]), excludedStoreId = ref42[0], setExcludedStoreId = ref42[1];
    var ref43 = (0,react.useState)({
        countries: [],
        defaultCountry: INDIA_COUNTRY_OBJECT
    }), countriesData = ref43[0], setCountriesData = ref43[1];
    var ref44 = (0,react.useState)({}), invalidInputIdsMap = ref44[0], setInvalidInputIdsMap = ref44[1];
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var cart = (0,es/* useSelector */.v9)(function(state) {
        return state.cartReducer;
    });
    var ref45 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer.data,
            userAddressList: state.userReducer.addressList,
            defaultAddress: state.userReducer.defaultAddress
        };
    }), userAddressList = ref45.userAddressList, userData = ref45.userData, defaultAddress = ref45.defaultAddress;
    var isIndiaSelected = (state.country || "").toLowerCase() === INDIA_COUNTRY_OBJECT.country.toLowerCase() && countriesData.defaultCountry.id === INDIA_COUNTRY_OBJECT.id;
    // for opening in editing mode
    (0,react.useEffect)(function() {
        if (props.edit_id && Array.isArray(userAddressList)) {
            var selectedAddFromUsersAddList = userAddressList === null || userAddressList === void 0 ? void 0 : userAddressList.find(function(el) {
                return el.address_id === Number(props.edit_id);
            });
            var ref;
            setState(function(state) {
                var ref1;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    user_name: selectedAddFromUsersAddList.user_name.text,
                    landmark: selectedAddFromUsersAddList.landmark.text,
                    pincode: selectedAddFromUsersAddList.pincode.text,
                    city: selectedAddFromUsersAddList.city.text,
                    address1: selectedAddFromUsersAddList.address1.text,
                    address2: selectedAddFromUsersAddList.address2.text,
                    addressType: selectedAddFromUsersAddList.address_type,
                    addressName: selectedAddFromUsersAddList.address_name || "Home",
                    user_id: selectedAddFromUsersAddList.user_id,
                    address_id: selectedAddFromUsersAddList.address_id,
                    state: selectedAddFromUsersAddList.state.text,
                    country: ((ref1 = selectedAddFromUsersAddList.country) === null || ref1 === void 0 ? void 0 : ref1.text) || INDIA_COUNTRY_OBJECT.country,
                    email_id: selectedAddFromUsersAddList.email_id.text,
                    age: selectedAddFromUsersAddList.age.text,
                    gender: selectedAddFromUsersAddList.gender.text,
                    alternate_phone: selectedAddFromUsersAddList.alternate_phone.text || (userData === null || userData === void 0 ? void 0 : userData.phone),
                    selectedAddress: selectedAddFromUsersAddList,
                    missing_fields: (ref = selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.missing_fields) !== null && ref !== void 0 ? ref : [],
                    custom_field_data_list: selectedAddFromUsersAddList.custom_field_data_list || []
                });
            });
            setCustomFieldList((selectedAddFromUsersAddList === null || selectedAddFromUsersAddList === void 0 ? void 0 : selectedAddFromUsersAddList.custom_field_data_list) || []);
            if (state.selectedAddress) {
                validate();
            }
        } else {
            var ref1;
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    user_name: "",
                    landmark: "",
                    pincode: "",
                    city: "",
                    state: "",
                    country: countriesData.defaultCountry.country,
                    address1: "",
                    address2: "",
                    addressName: "Home",
                    isLocationOn: false,
                    addressType: "home",
                    email_id: "",
                    age: "",
                    gender: "",
                    deliveryType: checkRenderEnv/* IS_SERVER */.W6 ? "" : cart === null || cart === void 0 ? void 0 : cart.order_type,
                    showOptionalFields: false,
                    alternate_phone: userData === null || userData === void 0 ? void 0 : userData.phone,
                    selectedAddress: defaultAddress,
                    missing_fields: (ref1 = defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.missing_fields) !== null && ref1 !== void 0 ? ref1 : [],
                    custom_field_data_list: (defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.custom_field_data_list) || []
                });
            });
            setCustomFieldList((defaultAddress === null || defaultAddress === void 0 ? void 0 : defaultAddress.custom_field_data_list) || []);
        }
        setInvalidInputIdsMap({});
    }, [
        props.edit_id,
        defaultAddress,
        state.selectedAddress
    ]);
    (0,react.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var filePath, response, fileContent, integers, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        filePath = "https://docs.google.com/spreadsheets/d/1ZLV7S5VvdHznmEFNz5AwasSjJlUjyAy0sbl-fTqax_Q/edit#gid=0";
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch(filePath)
                        ];
                    case 2:
                        response = _state.sent();
                        if (!response.ok) {
                            throw new Error("Failed to fetch file");
                        }
                        return [
                            4,
                            response.text()
                        ];
                    case 3:
                        fileContent = _state.sent();
                        integers = fileContent === null || fileContent === void 0 ? void 0 : fileContent.split("\n").map(function(row) {
                            return parseInt(row.trim(), 10);
                        }).filter(function(value) {
                            return !isNaN(value);
                        });
                        if (Array.isArray(integers)) {
                            setExcludedStoreId(integers);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Error fetching file:", error.message);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var isStoreExcluded = excludedStoreId.includes(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id);
    var handleInputChange = function(key, value, validationType, minLength, maxLength) {
        var newState = (0,_object_spread/* default */.Z)({}, state);
        if (!isStoreExcluded || key !== "pincode") {
            if (value.length > maxLength) value = value.substring(0, maxLength);
        }
        value = value.replace(getRegexByValidationType(validationType), "");
        if (isIndiaSelected && key === "pincode" && value.length === 6) {
            dispatch((0,user/* fetchCityStateFromPincode */.pl)(value, function(res) {
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        state: res.state,
                        city: res.city
                    });
                });
            }));
        }
        if (key === "gender" && !Object.values(constants/* GENDER_TYPES */.ps).includes(value)) {
            value = "";
        }
        var id = getIdByKey(key);
        if (invalidInputIdsMap[id] && value.trim()) {
            setInvalidInputIdsMap((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, invalidInputIdsMap), (0,_define_property/* default */.Z)({}, id, false)));
        }
        newState[key] = value;
        setState(newState);
    };
    var validate = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
        var idsMap = {};
        if (state.selectedAddress.user_name.is_mandatory && state.user_name.trim() === "") {
            idsMap[FIELDS_ID.Username] = true;
        }
        if (state.selectedAddress.address1.is_mandatory && state.address1.trim() === "") {
            idsMap[FIELDS_ID.Address1] = true;
        }
        if (state.selectedAddress.address2.is_mandatory && state.address2.trim() === "") {
            idsMap[FIELDS_ID.Address2] = true;
        }
        if (!isStoreExcluded && (state.selectedAddress.pincode.is_mandatory && state.pincode.trim() === "" || state.pincode.trim() !== "" && isIndiaSelected && ((ref = state.pincode.trim()) === null || ref === void 0 ? void 0 : ref.length) !== 6)) {
            idsMap[FIELDS_ID.Pincode] = true;
        }
        if (state.selectedAddress.city.is_mandatory && state.city.trim() === "") {
            idsMap[FIELDS_ID.City] = true;
        }
        if (state.selectedAddress.state.is_mandatory && state.state.trim() === "") {
            idsMap[FIELDS_ID.State] = true;
        }
        if (state.selectedAddress.landmark.is_mandatory && state.landmark.trim() === "") {
            idsMap[FIELDS_ID.Landmark] = true;
        }
        if (validateEmailError()) {
            idsMap[FIELDS_ID.EmailId] = true;
        }
        if (validateAlternatePhoneError()) {
            idsMap[FIELDS_ID.AlternatePhone] = true;
        }
        if (state.selectedAddress.age.is_mandatory && state.age.trim() === "") {
            idsMap[FIELDS_ID.Age] = true;
        }
        if (state.selectedAddress.gender.is_mandatory && state.gender.trim() === "") {
            idsMap[FIELDS_ID.Gender] = true;
        }
        if (((ref1 = state.selectedAddress) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.custom_field_data_list) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.custom_field_value) === null || ref4 === void 0 ? void 0 : ref4.is_mandatory) && !(customFieldList === null || customFieldList === void 0 ? void 0 : (ref5 = customFieldList[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.custom_field_value) === null || ref6 === void 0 ? void 0 : ref6.text)) {
            idsMap["".concat(FIELDS_ID.CustomFieldValue, "1")] = true;
        }
        if (((ref7 = state.selectedAddress) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.custom_field_data_list) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[1]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.custom_field_value) === null || ref10 === void 0 ? void 0 : ref10.is_mandatory) && !(customFieldList === null || customFieldList === void 0 ? void 0 : (ref11 = customFieldList[1]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.custom_field_value) === null || ref12 === void 0 ? void 0 : ref12.text)) {
            idsMap["".concat(FIELDS_ID.CustomFieldValue, "2")] = true;
        }
        if (Object.keys(idsMap).length) {
            setInvalidInputIdsMap(idsMap);
            return false;
        }
        return true;
    };
    var submitPlaceOrder = function() {
        var addressData = {
            address_id: state.address_id,
            user_id: userData === null || userData === void 0 ? void 0 : userData.user_id,
            address_type: state.addressType,
            address1: state.address1,
            address2: state.address2,
            latitude: state.latitude || 0,
            longitude: state.longitude || 0,
            phone_number: userData === null || userData === void 0 ? void 0 : userData.phone,
            city: state.city,
            google_address: "",
            pincode: state.pincode,
            landmark: state.landmark,
            user_name: state.user_name,
            alternate_phone: state.alternate_phone,
            email_id: state.email_id.trim(),
            state: state.state,
            country: state.country,
            gender: state.gender,
            age: state.age,
            address_name: state.addressName,
            custom_field_data_list: getCustomFieldDataList(),
            store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id
        };
        var orderData = (0,addDeliveryInfoInCart/* addDeliveryInfoInCart */.$)(cart, addressData);
        if (!jsonEqual(oldAddressData, addressData)) {
            dispatch((0,auth/* saveAddress */.Mw)(addressData, function(status) {
                if (status) {
                    setShowAddressError === null || setShowAddressError === void 0 ? void 0 : setShowAddressError(false);
                    oldAddressData = addressData;
                    addressData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addressData), {
                        address_id: constants/* DEFAULT_ADDRESS_ID */.kx
                    });
                    orderData = (0,addDeliveryInfoInCart/* addDeliveryInfoInCart */.$)(cart, addressData);
                    dispatch((0,actions_cart/* setCart */.RV)(orderData));
                    if ((0,isDeliveryPincodeBased/* isDeliveryPincodeBased */.y)()) (0,triggerGetServiceableAddressId/* triggerGetServiceableAddressId */.o)();
                    props.toggleAddDeliveryForm(false);
                }
            }));
        } else {
            props.toggleAddDeliveryForm(false);
        }
    };
    var onDeliverHereHandle = function() {
        var isValidated = validate();
        if (!isValidated) {
            (0,Toast/* toastNotifyError */.Lu)("Please fill all mandatory fields!");
            return;
        }
        dispatch((0,auth/* saveSelectedAddress */.z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            custom_field_data_list: getCustomFieldDataList(true)
        })));
        submitPlaceOrder();
    };
    var showError = !checkClientDeviceType/* IS_DESKTOP */.yn && showAddressError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "premium-add-delivery-page",
                children: [
                    showError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-mb-[16px] tw-text-xs tw-text-[#F63D60] md:tw-text-sm",
                        children: "Please add a delivery address before placing the order"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid ".concat(showError ? "tw-border-[#F63D60]" : "tw-border-[#E2E2E2]", " md:tw-overflow-visible md:tw-border-x-0 md:tw-border-b-0 md:tw-border-t"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            className: "premium-address-container",
                            id: "address-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "premium-address-container__wrap premium-wrapper-around ",
                                    children: [
                                        (state === null || state === void 0 ? void 0 : (ref = state.selectedAddress) === null || ref === void 0 ? void 0 : (ref1 = ref.user_name) === null || ref1 === void 0 ? void 0 : ref1.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                            type: "text",
                                            label: "Enter Recipient Name ".concat(!(state === null || state === void 0 ? void 0 : (ref2 = state.selectedAddress) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user_name) === null || ref3 === void 0 ? void 0 : ref3.is_mandatory) ? "(optional)" : "*"),
                                            id: FIELDS_ID.Username,
                                            className: invalidInputIdsMap[FIELDS_ID.Username] ? "!tw-border-b-[#F63D60]" : "",
                                            labelClasses: invalidInputIdsMap[FIELDS_ID.Username] ? "!tw-text-[#F63D60]" : "",
                                            value: state.user_name,
                                            disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                            onChange: function(e) {
                                                handleInputChange("user_name", e.target.value, VALIDATION_TYPES.ADDRESS, 0, 60);
                                            }
                                        }),
                                        (state === null || state === void 0 ? void 0 : (ref4 = state.selectedAddress) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.address1) === null || ref5 === void 0 ? void 0 : ref5.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                            label: "Enter Flat/ House No. / Floor ".concat(!(state === null || state === void 0 ? void 0 : (ref6 = state.selectedAddress) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.address1) === null || ref7 === void 0 ? void 0 : ref7.is_mandatory) ? "(optional)" : "*"),
                                            type: "text",
                                            id: FIELDS_ID.Address1,
                                            className: invalidInputIdsMap[FIELDS_ID.Address1] ? "!tw-border-b-[#F63D60]" : "",
                                            labelClasses: invalidInputIdsMap[FIELDS_ID.Address1] ? "!tw-text-[#F63D60]" : "",
                                            value: state.address1,
                                            disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                            onChange: function(e) {
                                                return handleInputChange("address1", e.target.value, VALIDATION_TYPES.ADDRESS, 0, 100);
                                            }
                                        }),
                                        (state === null || state === void 0 ? void 0 : (ref8 = state.selectedAddress) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.address2) === null || ref9 === void 0 ? void 0 : ref9.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                            label: "Enter Colony/ Street / Locality ".concat(!(state === null || state === void 0 ? void 0 : (ref10 = state.selectedAddress) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.address2) === null || ref11 === void 0 ? void 0 : ref11.is_mandatory) ? "(optional)" : "*"),
                                            type: "text",
                                            id: FIELDS_ID.Address2,
                                            className: invalidInputIdsMap[FIELDS_ID.Address2] ? "!tw-border-b-[#F63D60]" : "",
                                            labelClasses: invalidInputIdsMap[FIELDS_ID.Address2] ? "!tw-text-[#F63D60]" : "",
                                            value: state.address2,
                                            disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                            onChange: function(e) {
                                                return handleInputChange("address2", e.target.value, VALIDATION_TYPES.ADDRESS, 0, 100);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                            className: "premium-form-flex-row",
                                            children: [
                                                (state === null || state === void 0 ? void 0 : (ref12 = state.selectedAddress) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.pincode) === null || ref13 === void 0 ? void 0 : ref13.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                                    label: "Pincode ".concat(!(state === null || state === void 0 ? void 0 : (ref14 = state.selectedAddress) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.pincode) === null || ref15 === void 0 ? void 0 : ref15.is_mandatory) ? "(optional)" : "*"),
                                                    type: "text",
                                                    id: FIELDS_ID.Pincode,
                                                    className: invalidInputIdsMap[FIELDS_ID.Pincode] ? "!tw-border-b-[#F63D60]" : "",
                                                    labelClasses: invalidInputIdsMap[FIELDS_ID.Pincode] ? "!tw-text-[#F63D60]" : "",
                                                    value: state.pincode,
                                                    disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                                    onChange: function(e) {
                                                        return handleInputChange("pincode", e.target.value, isIndiaSelected ? VALIDATION_TYPES.NUMERIC : VALIDATION_TYPES.ALPHA_NUMERIC_INTERNATIONAL_PINCODE, 0, isIndiaSelected ? 6 : 15);
                                                    }
                                                }),
                                                (state === null || state === void 0 ? void 0 : (ref16 = state.selectedAddress) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.city) === null || ref17 === void 0 ? void 0 : ref17.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                                    label: "City ".concat(!(state === null || state === void 0 ? void 0 : (ref18 = state.selectedAddress) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.state) === null || ref19 === void 0 ? void 0 : ref19.is_mandatory) ? "(optional)" : "*"),
                                                    type: "text",
                                                    id: FIELDS_ID.City,
                                                    value: state.city,
                                                    className: invalidInputIdsMap[FIELDS_ID.City] ? "!tw-border-b-[#F63D60]" : "",
                                                    labelClasses: invalidInputIdsMap[FIELDS_ID.City] ? "!tw-text-[#F63D60]" : "",
                                                    disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                                    onChange: function(e) {
                                                        return handleInputChange("city", e.target.value, VALIDATION_TYPES.ADDRESS, 0, 40);
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                            className: "premium-form-flex-row",
                                            children: [
                                                (state === null || state === void 0 ? void 0 : (ref20 = state.selectedAddress) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.state) === null || ref21 === void 0 ? void 0 : ref21.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                                    label: "State ".concat(!(state === null || state === void 0 ? void 0 : (ref22 = state.selectedAddress) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.state) === null || ref23 === void 0 ? void 0 : ref23.is_mandatory) ? "(optional)" : "*"),
                                                    type: "text",
                                                    id: FIELDS_ID.State,
                                                    className: invalidInputIdsMap[FIELDS_ID.State] ? "!tw-border-b-[#F63D60]" : "",
                                                    labelClasses: invalidInputIdsMap[FIELDS_ID.State] ? "!tw-text-[#F63D60]" : "",
                                                    value: state.state,
                                                    disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                                    onChange: function(e) {
                                                        return handleInputChange("state", e.target.value, VALIDATION_TYPES.ADDRESS, 0, 50);
                                                    }
                                                }),
                                                ((ref24 = state.selectedAddress) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.country) === null || ref25 === void 0 ? void 0 : ref25.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_CountryInput, {
                                                    country: state.country,
                                                    INDIA_COUNTRY_OBJECT: INDIA_COUNTRY_OBJECT,
                                                    setCountry: setCountry,
                                                    countriesData: countriesData,
                                                    setCountriesData: setCountriesData
                                                })
                                            ]
                                        }),
                                        (state === null || state === void 0 ? void 0 : (ref26 = state.selectedAddress) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.landmark) === null || ref27 === void 0 ? void 0 : ref27.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                            label: "Landmark ".concat(!(state === null || state === void 0 ? void 0 : (ref28 = state.selectedAddress) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.landmark) === null || ref29 === void 0 ? void 0 : ref29.is_mandatory) ? "(optional)" : "*"),
                                            type: "text",
                                            id: FIELDS_ID.Landmark,
                                            className: invalidInputIdsMap[FIELDS_ID.Landmark] ? "!tw-border-b-[#F63D60]" : "",
                                            labelClasses: invalidInputIdsMap[FIELDS_ID.Landmark] ? "!tw-text-[#F63D60]" : "",
                                            value: state.landmark,
                                            disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                            onChange: function(e) {
                                                return handleInputChange("landmark", e.target.value, VALIDATION_TYPES.ADDRESS, 0, 50);
                                            }
                                        }),
                                        (state === null || state === void 0 ? void 0 : (ref30 = state.selectedAddress) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.email_id) === null || ref31 === void 0 ? void 0 : ref31.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                            label: "Email ID ".concat(!(state === null || state === void 0 ? void 0 : (ref32 = state.selectedAddress) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.email_id) === null || ref33 === void 0 ? void 0 : ref33.is_mandatory) ? "(optional)" : "*"),
                                            type: "text",
                                            id: FIELDS_ID.EmailId,
                                            className: invalidInputIdsMap[FIELDS_ID.EmailId] ? "!tw-border-b-[#F63D60]" : "",
                                            labelClasses: invalidInputIdsMap[FIELDS_ID.EmailId] ? "!tw-text-[#F63D60]" : "",
                                            value: state.email_id,
                                            disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                            onChange: function(e) {
                                                return handleInputChange("email_id", e.target.value, VALIDATION_TYPES.ADDRESS, 0, 80);
                                            }
                                        }),
                                        (state === null || state === void 0 ? void 0 : (ref34 = state.selectedAddress) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.alternate_phone) === null || ref35 === void 0 ? void 0 : ref35.visibility) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Premium_Input, {
                                            label: "Mobile Number ".concat(!(state === null || state === void 0 ? void 0 : (ref36 = state.selectedAddress) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.alternate_phone) === null || ref37 === void 0 ? void 0 : ref37.is_mandatory) ? "(optional)" : "*"),
                                            type: "text",
                                            id: FIELDS_ID.AlternatePhone,
                                            className: invalidInputIdsMap[FIELDS_ID.AlternatePhone] ? "!tw-border-b-[#F63D60]" : "",
                                            labelClasses: invalidInputIdsMap[FIELDS_ID.AlternatePhone] ? "!tw-text-[#F63D60]" : "",
                                            value: state.alternate_phone,
                                            disabled: state.deliveryType === constants/* ORDER_TYPE.PICKUP */.Jm.PICKUP,
                                            onChange: function(e) {
                                                return handleInputChange("alternate_phone", e.target.value, VALIDATION_TYPES.NUMERIC, 0, isIndiaSelected ? 12 : 15);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_CustomFields, {
                                            setCustomFieldList: setCustomFieldList,
                                            customFieldsList: customFieldList,
                                            invalidInputIdsMap: invalidInputIdsMap,
                                            state: state
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_AgeAndGenderInput, {
                                            state: state,
                                            handleInputChange: handleInputChange,
                                            setGender: setGender,
                                            invalidInputIdsMap: invalidInputIdsMap
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_AddressTypesAndName, {
                                    state: state,
                                    setState: setState
                                }),
                                renderSaveButton()
                            ]
                        })
                    })
                ]
            }),
            orderConfirmLoaderToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderConfirmLoader/* default */.Z, {
                isVisible: orderConfirmLoaderToggle,
                closeModal: function() {
                    return setOrderConfirmLoaderToggle(!orderConfirmLoaderToggle);
                },
                submitAction: submitPlaceOrder,
                deliveryType: 0
            })
        ]
    });
};
/* harmony default export */ var containers_AddDelivery = (AddDelivery);


/***/ }),

/***/ 68068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ addDeliveryInfoInCart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);



/**
 * add delivery info in cart
 * @param {*} cart
 * @param {*} address
 * @return {*} cartWithDeliveryInfo
 */ var addDeliveryInfoInCart = function(cart, address) {
    var ref;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, cart), {
        delivery_info: {
            deliver_to: address.user_name,
            address1: address.address1,
            address2: address.address2,
            pincode: address.pincode,
            city: address.city,
            state: address.state,
            country: address.country,
            landmark: address.landmark,
            address_id: address.address_id ? address.address_id : _constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_ADDRESS_ID */ .kx,
            latitude: address.latitude,
            longitude: address.longitude,
            alternate_phone: address.alternate_phone,
            email_id: address.email_id,
            gender: address.gender,
            age: address.age,
            custom_field_data_list: (ref = address === null || address === void 0 ? void 0 : address.custom_field_data_list) !== null && ref !== void 0 ? ref : []
        }
    });
};


/***/ }),

/***/ 26188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ isValidEmail; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);

function isValidEmail(email) {
    return _constants__WEBPACK_IMPORTED_MODULE_0__/* .EMAIL_REGEX_ADDRESS.test */ .O_.test(email);
}


/***/ }),

/***/ 67058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ triggerGetServiceableAddressId; }
});

// EXTERNAL MODULE: ./src/redux/actions/delivery.js
var delivery = __webpack_require__(79977);
// EXTERNAL MODULE: ./src/redux/store/index.js + 43 modules
var store = __webpack_require__(80344);
;// CONCATENATED MODULE: ./src/utils/getCartItemId.js

/**
 * @returns {array} item Id's inside Cart.
 */ function getCartItemId() {
    var ref;
    var item_id = [];
    var cartData = store/* default.getState */.Z.getState().cartReducer;
    for(var i = 0; i < (cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.length); i++){
        var ref1, ref2;
        item_id.push(cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[i]) === null || ref2 === void 0 ? void 0 : ref2.item_id);
    }
    return item_id;
}

// EXTERNAL MODULE: ./src/utils/getStringifyAddress.js
var getStringifyAddress = __webpack_require__(97978);
;// CONCATENATED MODULE: ./src/utils/getPincodeAddressId.js


/**
 * returns array of Pincode mapped with corresponding address_id
 * @returns {array} pincode and address_id array
 */ function getPincodeAddressId() {
    var ref;
    var pincode_address_id = [];
    var userData = store/* default.getState */.Z.getState().userReducer;
    for(var i = 0; i < (userData === null || userData === void 0 ? void 0 : (ref = userData.addressList) === null || ref === void 0 ? void 0 : ref.length); i++){
        var ref1;
        var addressDetails = (0,getStringifyAddress/* getStringifyAddress */.H)(userData === null || userData === void 0 ? void 0 : (ref1 = userData.addressList) === null || ref1 === void 0 ? void 0 : ref1[i]);
        pincode_address_id.push({
            pincode: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.pincode,
            address_id: addressDetails === null || addressDetails === void 0 ? void 0 : addressDetails.address_id
        });
    }
    return pincode_address_id;
}

;// CONCATENATED MODULE: ./src/utils/triggerGetServiceableAddressId.js




function triggerGetServiceableAddressId() {
    var ref, ref1;
    var storeData = store/* default.getState */.Z.getState().storeReducer.store;
    var userData = store/* default.getState */.Z.getState().userReducer;
    if (!(userData === null || userData === void 0 ? void 0 : (ref = userData.addressList) === null || ref === void 0 ? void 0 : ref.length)) return;
    var payload = {
        item_ids: getCartItemId(),
        pincode_address_ids: getPincodeAddressId(),
        store_id: storeData.store_id
    };
    if ((ref1 = payload.item_ids) === null || ref1 === void 0 ? void 0 : ref1.length) store/* default.dispatch */.Z.dispatch((0,delivery/* getServiceableAddressId */.vU)(payload));
}


/***/ }),

/***/ 5305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useIsClickOutside(ref) {
    var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    for(var _len = arguments.length, callbackArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        callbackArgs[_key - 2] = arguments[_key];
    }
    var handleClickOutside = function handleClickOutside(e) {
        var _$ref;
        if (!((_$ref = e.composedPath()) === null || _$ref === void 0 ? void 0 : _$ref.includes(ref.current))) {
            e.stopPropagation();
            callback && callback.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(callbackArgs));
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsClickOutside);


/***/ })

}]);